module.exports = __webpack_public_path__ + "img/logo.e964ada1.png";